@if (showChartTitle) {
<div
  class="card-heading table-Header-Nav-font"
  [ngClass]="customStyle === 'noMargin' ? 'noMarginClass' : 'chart-title'"
>
  {{ title }}
</div>
}
<div id="d" class="donut-chart">
  <div class="pie_div tcmcomponent-pie_div-height tcmcomponent-pie_div-padding pie_div-padding"></div>
  @if (loading) {
  <div class="donut-state" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading chart...</div>
  </div>
  } @if (!loading && errorMessage) {
  <div class="donut-state donut-error">
    {{ errorMessage }}
  </div>
  } @if (!loading && !errorMessage && noDataFound) {
  <div class="donut-state">
    No data found.
  </div>
  }
  <div class="donutcharttooltip"></div>
</div>
